/* eslint-disable global-require */

// const LoadStore = r => require.ensure([], () => r(require('@core/store')), 'group-amd');
const Empty = r => require.ensure([], () => r(require('@ui/pages/Empty')), 'group-amd');
const Dashboard = r => require.ensure([], () => r(require('@ui/pages/Dashboard')), 'group-amd');

const DEFAULT_ROUTE_PATH = '/amd/dashboard';

const LPA_ROUTE_HASH_CONFIG = {
  SHOW_SKILLS: '#lpa-view-skills',
  SHOW_QUEUE_SUMMARY: '#lpa-view-qs',
};

const routes = [
  {
    name: 'dashboard',
    path: DEFAULT_ROUTE_PATH,
    components: { amd: Dashboard },
  },
  {
    name: 'empty',
    path: '/amd/empty',
    components: { amd: Empty },
  },
  {
    name: 'default',
    path: '/amd/*',
    redirect: { path: DEFAULT_ROUTE_PATH },
  },
];

export {
  DEFAULT_ROUTE_PATH,
  LPA_ROUTE_HASH_CONFIG,
};

export default routes;
